import { render, staticRenderFns } from "./select2.vue?vue&type=template&id=dbcebf64&scoped=true&"
import script from "./select2.vue?vue&type=script&lang=js&"
export * from "./select2.vue?vue&type=script&lang=js&"
import style0 from "./select2.vue?vue&type=style&index=0&id=dbcebf64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcebf64",
  null
  
)

export default component.exports